/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
// eslint-disable-next-line max-lines-per-function
import { captureException, captureMessage } from '@sentry/browser';
import { BReactComponent } from 'blocks-cloud/b-react-component';
import { getDownloadDropdownList } from 'Cloud/Application/Editor/MyOffice/myOffice.helpers';
import features from 'Cloud/Application/Features';
import { Promo } from 'Cloud/Application/Promo';
import { promoController } from 'Cloud/Application/PromoController';
import { callApiR7Convert } from 'Cloud/Application/r7helpers';
import config from 'Cloud/config';
import { epsilonTime } from 'lib/epsilonTime';
import { extInfo } from 'lib/extInfo';
import { logger } from 'lib/logger';
import { addParams } from 'lib/urlUtils';
import { xray } from 'lib/xray';
import { clone } from 'ramda';
import {
    EDITORS_CONFIG,
    IS_FREE_B2B_BIZ_EDITORS_USER,
    IS_MOBILE_BROWSER,
    IS_MY_TEAM,
    IS_TABLET_BROWSER,
    VIEWERS_CONFIG,
} from 'reactApp/appHelpers/configHelpers';
import {
    clearNotificationAboutCreatingCopyOfNoneditableFile,
    getNotificationAboutCreatingCopyOfNoneditableFile,
    NotifyFrom,
} from 'reactApp/appHelpers/notificationAboutCreatingCopyOfNoneditableFile';
import { publishHelper } from 'reactApp/appHelpers/publishHelper';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import {
    renderBizPaidEditorDialog,
    renderComfirmationDialog,
    renderMessageBox,
} from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { renderOpenDocument } from 'reactApp/components/OpenDocument/openDocument.toolkit';
import { composeAvailableEditors, composeExtensions, composeSharedExtensions } from 'reactApp/modules/editor/editor.helpers';
import { startEditor } from 'reactApp/modules/editor/editor.module';
import { getEditorsByExtension } from 'reactApp/modules/editor/editor.selectors';
import { getFeatureMyOfficeSendDetailRadars } from 'reactApp/modules/features/features.selectors';
import { makeNewDocumentSuccess } from 'reactApp/modules/modifying/modifying.actions';
import { routeStatusPage } from 'reactApp/modules/router/router.module';
import { SettingsSelectors } from 'reactApp/modules/settings/settings.selectors';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { getCurrentItem, getItemById, isMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { EStatus } from 'reactApp/sections/ErrorPage/ErrorPage.types';
import { store as reduxStore } from 'reactApp/store';
import { CreateDocumentQueryAction } from 'reactApp/types/create-document-query-action';
import { openDisabledFeaturePopupHelper } from 'reactApp/ui/DisabledFeatureDialog/DisabledFeatureDialog.helpers';
import { DisabledFeature } from 'reactApp/ui/DisabledFeatureDialog/DisabledFeatureDialog.types';
import { EditorHeader } from 'reactApp/ui/EditorHeader/EditorHeader';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { sendViewerDwh } from 'reactApp/ui/ReactViewer/ReactViewer.helpers';
import { sessionWatcher } from 'reactApp/ui/ReactViewer/SessionWatcher';
import { callWopiEditAPICall } from 'reactApp/utils/wopiHelpers';

import { BUBBLE_ID, EDITORS, Editors, EditorsIds, X_IN_SHARED_FOLDER } from './Editor/config';
import {
    callApiCreateDoc,
    createWindowName,
    getExt,
    getIsOpenDocumentWarning,
    getUrlV2,
    isOpenedTab,
    joinPath,
    setIsOpenDocumentWarning,
    shortenFilename,
} from './Editor/helpers';
import { addEditorMessageListener, logEditorOpenError, startEditorSuccessWaiter } from './EditorStatistics';

let isEnabledBubble = false;
let tabs = {};

// CLOUDWEB-5491, CLOUDWEB-5602, CLOUDWEB-5605, CLOUDWEB-5606

let tabGCTimeoutId = 0;

const startTabGC = () => {
    window.clearTimeout(tabGCTimeoutId);

    Object.keys(tabs).forEach(function (tabName) {
        if (!isOpenedTab(tabs[tabName])) {
            // затираем ссылку на вкладку тк с помощью delete она не удаляется
            tabs[tabName] = null;
            delete tabs[tabName];
        }
    });

    tabGCTimeoutId = window.setTimeout(startTabGC, 60000);
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const Editor = (app, _) => {
    const editors = EDITORS_CONFIG.length ? EDITORS_CONFIG : VIEWERS_CONFIG;
    const HAS_SHARED_EDITOR = editors.some((editor) => X_IN_SHARED_FOLDER in editor);
    const IS_WEBKIT = app.browser.isWebKit();
    const ITEM_WITHOUT_HASH_MAX_SIZE = config.get('ITEM_WITHOUT_HASH_MAX_SIZE');

    // @ts-ignore
    const DETAILED_RADARS = features.getFeatureParam('detailedRadars', 'editor', false);
    const IS_REACT_PAGE = config.get('REACT_PAGE');
    const current = config.get('EDITOR') || {};

    const extensions = composeExtensions(editors);
    const editorsMap = composeAvailableEditors(editors, extensions);
    const sharedExtensions = composeSharedExtensions(editors, extensions);

    const getByExt = (item: any) => extensions[getExt(item)] || { editors: [] };

    function openEditor(editor: any, item: any, newExt?: string | null, force?: boolean) {
        const isCreate = !!newExt;
        const mode = isCreate ? 'create' : 'edit';
        const ext = item.ext2 || item.ext;

        if (!editor) {
            snackbarController.showSnackbar({
                id: 'no-editor',
                closable: true,
                text: `Не удалось открыть на редактирование файл этого  формата`,
                type: SnackbarTypes.failure,
                closeTimeout: 5000,
            });

            return;
        }

        if (!force) {
            if (IS_FREE_B2B_BIZ_EDITORS_USER && !editor) {
                renderBizPaidEditorDialog();
                return;
            }

            const state = reduxStore.getState();
            const isSharedOrMountedState = isMountedOrSharedFolder(state, item);
            const isMounted = isSharedOrMountedState && isSharedOrMountedState.isMounted;
            const lastId = isSharedOrMountedState && isSharedOrMountedState.folderId;
            const isSharedOrMounted = isSharedOrMountedState && isSharedOrMountedState.is;
            const folder = lastId && getItemById(state, lastId);

            // @ts-ignore
            if (isMounted && folder && folder.isReadOnly) {
                renderMessageBox({
                    dataQAId: 'document-edit-readonly-folder-dialog',
                    title: `${isCreate ? 'Папка доступна' : 'Файл доступен'} только для просмотра`,
                    renderContent: () =>
                        `Общая папка доступна вам только для просмотра. ${
                            isCreate ? 'Вы не можете создавать в ней файлы.' : 'Вы не можете редактировать содержащиеся в ней файлы.'
                        }`,
                });

                logEditorOpenError(editor.id, 'readonly');

                return;
            }

            if (
                !isCreate &&
                isSharedOrMounted &&
                !editor[X_IN_SHARED_FOLDER] &&
                !editor['x-skip-shared-folder-warning'] &&
                !getIsOpenDocumentWarning(HAS_SHARED_EDITOR)
            ) {
                renderOpenDocument({
                    hasSharedEditor: HAS_SHARED_EDITOR,
                    onSuccess: () => {
                        setIsOpenDocumentWarning(HAS_SHARED_EDITOR);
                        openEditor(editor, item, newExt, true);
                    },
                });

                return;
            }
        }

        if (editor['x-counter']) {
            app.counter(editor['x-counter']);
        }

        let tabName = createWindowName(editor.id, item);

        {
            // CLOUDWEB-5491, CLOUDWEB-5602, CLOUDWEB-5605, CLOUDWEB-5606
            if (isCreate) {
                // Открываем новую вкладку с редактором
                // для каждого нового документа.
                tabName += Date.now().toString(36);
            }

            // Chrome, Opera и Safari позволяют переключиться
            // на вкладку с редактором. IE включает мигание вкладки.
            tabs = tabs || {};
            const tab = tabs[tabName];

            if (tab) {
                // Для этого документа уже открывалась вкладка с редактором.
                if (isOpenedTab(tab)) {
                    // Вкладка редактора для этого документа все еще открыта.
                    // Просто переключаемся на вкладку с редактором
                    // и завершаем дальнейшее выполнение openEditor.
                    tab.focus();

                    if (!IS_WEBKIT) {
                        // В IE включится мигание вкладки, по переключение
                        // не произойдет. Firefox вообще никак не отрегаирует.
                        // Поэтому показываем пользователю bubble.
                        const message = 'Документ «{NAME}» уже открыт для редактирования.'.replace(
                            '{NAME}',
                            shortenFilename(item, 60).split('').join('\u200B')
                        ); // TODO: use b-filename

                        const isViewerVisible = ViewerSelectors.isViewerActive(reduxStore.getState());
                        if (!isViewerVisible) {
                            snackbarController.showSnackbar({
                                id: 'error',
                                text: message,
                                type: SnackbarTypes.failure,
                                closable: true,
                            });
                        }
                    }

                    return;
                }
                // Вкладка редактора для этого документа уже закрыта,
                // удаляем ненужную сслыку на старый инстанс Window.
                delete tabs[tabName];
            }
        }

        const openTab = editor['x-open-popup'] ? _.openPopup : _.openTab;

        // RADAR.ga('send', 'event', 'open_for_' + mode, newExt || item.ext, editor.id.toLowerCase());

        const radar = RADAR.group(`app_edit-${editor.id.toLowerCase()}`);

        radar.add(mode);
        radar.add(`${mode}_${newExt || item.ext}`);
        radar.send();

        if (editor.id !== Editors.R7 && editor.id !== Editors.MYOFFICE) {
            startEditorSuccessWaiter(item, editor.id, false);
        }

        const processApiError = (errors) => {
            openTab('/500', tabName);

            logEditorOpenError(editor.id, 'apierror');

            captureMessage('EDITOR ERROR', {
                arguments: {
                    item,
                    errors,
                },
            } as any);
        };

        const promise = new Promise((resolve, reject) => {
            const convertExt = editor.convert_extensions[ext];
            if (editor.id === Editors.R7 && convertExt) {
                renderComfirmationDialog({
                    dataQAId: 'document-convert-confirmation-dialog',
                    renderContent: () =>
                        `Формат файла не поддерживается. Создать копию в поддерживаемом формате ${convertExt} и начать редактирование?`,
                    onSuccess: () => {
                        // TODO: где-то тут надо будет потом доработать от продукта
                        // что делать и как проверять, что файл уже существует,
                        // нужно ли спрашивать юзера про новое имя и тп
                        callApiR7Convert(item.id)
                            .then(({ data }) => {
                                resolve({ id: data.path, storage: item.storage, ext: convertExt });
                            })
                            .catch((err) => {
                                snackbarController.showSnackbar({
                                    id: 'document-convert-error',
                                    type: SnackbarTypes.failure,
                                    text: `Не удалось сконвертировать документ: ${err}`,
                                    closable: true,
                                });
                                reject();
                            });
                    },
                    onClose: () => reject(),
                });
            } else {
                // @ts-ignore
                resolve();
            }
        });

        promise.then((newItem) => {
            const queryParams = SettingsSelectors.getQueryParams(reduxStore.getState());

            const queryAction = queryParams.action as CreateDocumentQueryAction | undefined;
            const createDocByLink =
                queryAction && [CreateDocumentQueryAction.CREATE_DOCX, CreateDocumentQueryAction.CREATE_XLSX].includes(queryAction);

            if (!IS_MY_TEAM && !createDocByLink /* CLOUDWEB-14757: не нужно что бы открывался таб */) {
                openTab('about:blank', tabName);
            }

            // после конвертации редактор по-умолчанию может измениться
            if (newItem) {
                editor = editorsMap[app.editor.getDefaultEditorId(newItem)];
            }

            const url = getUrlV2(editor, { item: newItem || item, newExt, token: null });
            let tab = null;

            // CLOUDWEB-5491, CLOUDWEB-5602, CLOUDWEB-5605, CLOUDWEB-5606
            if (isCreate) {
                callApiCreateDoc(url, newExt)
                    .then(({ data = '' }) => {
                        const editUrl = getUrlV2(editor, { item: { id: joinPath(item.id, data.name) }, newExt: null, token: null });

                        const name = IS_MY_TEAM ? '_self' : tabName;

                        if (!createDocByLink /* CLOUDWEB-14757: не нужно что бы открывался таб */) {
                            tab = openTab(editUrl, name);
                        } else {
                            /* Не энкодим, потому что доверяем getUrlV2 */
                            window.location.href = editUrl;
                        }

                        if (IS_REACT_PAGE) {
                            reduxStore.dispatch(makeNewDocumentSuccess());
                        }
                    })
                    .catch(processApiError);
            } else if (IS_MY_TEAM) {
                window.open(url, '_self');
            } else {
                // Chrome, Opera и Safari позволяют переключиться
                // на вкладку с редактором, а IE включает мигание
                // вкладки, для этого запоминаем ссылку
                // на соответствующий инстанс Window.
                tab = openTab(url, tabName);

                startTabGC();
            }

            if (tab) {
                tabs[tabName] = tab;
            }
        });
    }

    Object.assign(app, {
        editor: {
            isEditor() {
                return current && current.id && editorsMap[current.id];
            },

            getDefaultEditorId(item, isCreate) {
                const hasSharedEditor = HAS_SHARED_EDITOR && sharedExtensions[getExt(item)];
                const isSharedFolder = hasSharedEditor && app.isMountedOrSharedFolder(isCreate ? app.currentFolder() : item).is;
                const editors = getEditorsByExtension(reduxStore.getState(), getExt(item) as any);

                if (item.storage === EStorageType.attaches && editors.includes(EditorsIds.myofficeAttaches)) {
                    return EditorsIds.myofficeAttaches;
                }

                return editors.find((editorId) => {
                    return hasSharedEditor && isSharedFolder
                        ? editorsMap[editorId].default === 'shared-folder'
                        : editorsMap[editorId].default || editors.length === 1;
                });
            },

            getEditorsFor(item) {
                const result: any[] = [];

                if (!item) {
                    return result;
                }

                if (item.id === EditorsIds.myofficeAttaches) {
                    result.push(editorsMap[item.id]);
                }

                const size = item.size || 0;

                if (size <= ITEM_WITHOUT_HASH_MAX_SIZE) {
                    // для файлов размером меньше 21 байта просмотр недоступен
                    return result;
                }

                const extData = extInfo.get(item.ext);
                const maxSize =
                    typeof extData.maxEditableSize === 'object'
                        ? extData.maxEditableSize[current.id || 'default'] || extData.maxEditableSize.default
                        : extData.maxEditableSize;

                if (!maxSize || size > maxSize) {
                    return result;
                }

                let isSharedFolder = false;
                const hasSharedEditor = HAS_SHARED_EDITOR && sharedExtensions[getExt(item)];
                if (hasSharedEditor) {
                    isSharedFolder = app.isMountedOrSharedFolder(item).is;
                }

                if (IS_REACT_PAGE) {
                    if (
                        item.storage !== EStorageType.home &&
                        item.storage !== EStorageType.feed &&
                        item.storage !== EStorageType.alldocuments
                    ) {
                        return result;
                    }
                } else if (!(app.isHome() || app.isFavorites() || app.isSearch() || app.isFeed() || app.isEditor() || app.isAttaches())) {
                    return result;
                }

                getByExt(item).editors.forEach((id) => {
                    let editor = editorsMap[id];
                    const isDefault = hasSharedEditor && isSharedFolder ? editor.default === 'shared-folder' : !!editor.default;

                    if (!hasSharedEditor || !editor[X_IN_SHARED_FOLDER] || isSharedFolder) {
                        editor = Object.assign(
                            {},
                            editor,
                            {
                                icon: editor.icon ? editor.icon[item.ext] : undefined,
                                icon_big: editor.icon_big[item.ext],
                            },
                            {
                                name: editor.id,
                                text: editor.title,
                            }
                        );

                        if (isDefault) {
                            // default is always first
                            result.unshift(editor);
                        } else {
                            result.push(editor);
                        }
                    }
                });

                return result;
            },

            openEditor(item, editorId) {
                if (app.user.isOverquota()) {
                    openDisabledFeaturePopupHelper({ disabledFeature: DisabledFeature.newFile });
                    return;
                }
                if (!editorId) {
                    editorId = this.getDefaultEditorId(item, false);
                }
                openEditor(editorsMap[editorId], item);
            },

            createNew(ext, editorId, currentFolder) {
                if (!editorId) {
                    editorId = this.getDefaultEditorId(ext, true);
                }

                if (IS_FREE_B2B_BIZ_EDITORS_USER && !editorId) {
                    renderBizPaidEditorDialog();
                    return;
                }

                openEditor(editorsMap[editorId], { id: currentFolder }, ext);
            },

            clearWindowName() {
                // CLOUDWEB-6848
                // Необходимо очищать window.name после загрузки Облака
                // в окне редактора, чтобы разрешить повторное редактирование.
                if (!app.editor.isEditor()) {
                    const defaultWindowName = '';
                    const currentWindowName = window.name || defaultWindowName;
                    const editor = editors.find(function (editor) {
                        return currentWindowName.indexOf(`${editor.id}_`) === 0;
                    });

                    if (editor) {
                        window.name = defaultWindowName;

                        const radar = RADAR.group('app_clear-win-name');

                        radar.add(String(editor.id).toLowerCase());
                        radar.add('all');
                        radar.send();

                        return true;
                    }
                }

                return false;
            },

            start() {
                const onRouteEnd = async function () {
                    const currentExt = String(current.ext).toLowerCase();
                    const navigationStart = window.performance && performance.timing && performance.timing.navigationStart;
                    const radarGroup = `editors-${current.id}`;
                    const isEditorMyOffice = current.id === Editors.MYOFFICE;

                    const editorCount = app.editor.getEditorsFor(app.current() || current).length;

                    const sendEpsilonTime = function (lable: string, time = 0) {
                        if (DETAILED_RADARS) {
                            // CLOUDWEB-7854
                            if (arguments.length < 2) {
                                time = Date.now() - navigationStart;
                            }

                            // eslint-disable-next-line new-cap
                            RADAR(`${radarGroup}_${lable}_time-${time > 60000 ? 'over1m' : epsilonTime(time)}`);
                        }
                    };

                    const radar = RADAR.group(radarGroup);

                    radar.add('open');
                    radar.add(`open_${currentExt}`);
                    sendEpsilonTime(`open_${currentExt}`);

                    const currentEditorConfig = editors.find((editor) => editor.id === current.id);
                    let editor = currentEditorConfig && EDITORS[current.id];
                    let frameData = current.data;

                    const editorWaiting = document.querySelector('#editor__waiting') as HTMLElement;
                    const state = reduxStore.getState();
                    const isWopiEnabled = ViewerSelectors.isWopiEnabled(state, currentExt);

                    if (isWopiEnabled && currentEditorConfig.wopi) {
                        try {
                            const { data } = await callWopiEditAPICall(app.getState().id, current.id);
                            const url = addParams(data?.url, {
                                title: 'title',
                                lang: 'ru-ru',
                                closebutton: 1,
                                revisionhistory: 1,
                            });

                            frameData = {
                                ...data,
                                [`${current.mode}_url`]: url,
                            };
                        } catch (error) {
                            logger.error(error);
                            captureException(error);
                            frameData = null;
                        }
                    }

                    if (!editor || !frameData || (!app.isPublic() && editorCount === 0)) {
                        radar.add('error').send();
                        sendEpsilonTime('error');
                        reduxStore.dispatch(routeStatusPage({ status: EStatus.NOT_FOUND }));
                    } else if (!frameData.edit_url || (!frameData.access_token && !isEditorMyOffice)) {
                        radar.add('error').send();
                        sendEpsilonTime('error');
                        reduxStore.dispatch(routeStatusPage({ status: EStatus.INTERNAL_SERVER_ERROR }));
                    } else {
                        editor = new EDITORS[current.id]({
                            mode: current.mode,
                            editorId: current.id,
                        });

                        const item = app.get(app.getState().id) || getCurrentItem(reduxStore.getState());
                        reduxStore.dispatch(
                            startEditor({
                                editorId: current.id,
                                item: !app.isPublic() ? clone(item) : undefined,
                            })
                        );

                        const notifyMeta = reduxStore.dispatch(getNotificationAboutCreatingCopyOfNoneditableFile());
                        const createdFileId = notifyMeta?.newId;
                        const notifyFrom = notifyMeta?.from;
                        const currentFileId = item?.id;

                        if (createdFileId && createdFileId === currentFileId) {
                            const { buttonText, onButtonClick } = {
                                [NotifyFrom.home]: {
                                    buttonText: 'Перейти к файлу',
                                    onButtonClick: () =>
                                        toolbarActions.showInParentFolder({ folderId: item.parent, itemId: currentFileId }),
                                },
                                [NotifyFrom.sharedHome]: {
                                    buttonText: 'Настроить доступ',
                                    onButtonClick: () => toolbarActions.publish('editor', currentFileId),
                                },
                            }[notifyFrom];
                            snackbarController.showSnackbar({
                                id: 'create-copy-of-non-editable-file-success',
                                closable: true,
                                text: 'Документ создан',
                                buttonText,
                                onButtonClick,
                                type: SnackbarTypes.success,
                                oneline: true,
                                closeTimeout: 5000,
                            });
                            reduxStore.dispatch(clearNotificationAboutCreatingCopyOfNoneditableFile());
                        }

                        const header = document.querySelector('#react-header');

                        if (header && [Editors.R7, Editors.MYOFFICE, Editors.MYOFFICEATTACHES].includes(current.id)) {
                            const file = app.get(app.getState().id) || getCurrentItem(state);
                            const isMyOfficeSendDetailRadars = getFeatureMyOfficeSendDetailRadars(state);

                            if (isMyOfficeSendDetailRadars && (current.id === Editors.MYOFFICE || currentEditorConfig.wopi)) {
                                /** Проверка на флаг для моего офиса(моб/десктоп)
                                 *
                                 *  {@link https://jira.vk.team/browse/CLOUDWEB-13905 Задача}
                                 */
                                const deviceType = !IS_MOBILE_BROWSER ? 'desktop' : 'mobile';
                                const viewerType = isWopiEnabled && currentEditorConfig.wopi ? 'wopi' : 'amr';
                                const mode = 'edit';

                                /** Формат радара для моего офиса
                                 *    @example Пример.
                                 *    myoffice_open_<device_type>_<viewer_type>_<mode>_<ext>
                                 */
                                xray.send(`myoffice_open_${deviceType}_${viewerType}_${mode}_${file.ext}`);
                            }

                            startEditorSuccessWaiter(file, current.id, true);

                            if (current.id !== Editors.MYOFFICE) {
                                const documentBubble = Object.assign(new Promo(BUBBLE_ID), {
                                    isEnabled() {
                                        return isEnabledBubble;
                                    },
                                });

                                if (!isEnabledBubble) {
                                    promoController.register(1, documentBubble);
                                }

                                isEnabledBubble = true;
                            }

                            const reactHeader = new BReactComponent({
                                ReactComponent: EditorHeader,
                                renderMode: 'append',
                            });

                            reactHeader.renderTo(header, {
                                props: {
                                    showBubble: promoController.canShow(BUBBLE_ID),
                                    onBubbleShow: () => {
                                        // @ts-ignore
                                        promoController.markAsShown(BUBBLE_ID);
                                    },
                                    isPublic: !!app.isPublic(),
                                    isStock: !!app.isStock(),
                                    enableFavorites: !app.isPublic() && !app.isMountedOrSharedFolder(file).isMounted,
                                    gaCategory: current.id === Editors.R7 ? 'r7-edtr' : 'myoffice',
                                    downloadDropdownList: isEditorMyOffice ? getDownloadDropdownList(file.name, file.ext) : null,
                                    editorId: current.id,
                                },
                            });

                            if (IS_TABLET_BROWSER && file.kind === 'document') {
                                // eslint-disable-next-line new-cap
                                RADAR(`public-mobile_openrw_${file.ext2}`);

                                const reactDialog = new BReactComponent({
                                    ReactComponent: MobileDialog,
                                    renderMode: 'append',
                                });

                                const publicNotifyEl = document.querySelector('.js-react-public-notify');
                                if (publicNotifyEl) {
                                    reactDialog.renderTo(publicNotifyEl, {
                                        props: {
                                            title: 'Редактирование недоступно в мобильном браузере',
                                            text: 'Пожалуйста, откройте ссылку на вашем компьютере',
                                            closableStateInside: true,
                                            isTablet: true,
                                            mod: 'mobileV1',
                                        },
                                    });
                                }
                            }
                        }

                        const sendInfo = (status: string, frameStartTime: number) => {
                            if (navigationStart) {
                                const time = Date.now() - navigationStart;

                                radar.add('load', time);
                                radar.add(`${'load_'}${currentExt}`, time);
                                radar.add(`load_${status}`, time);
                                radar.add(`load_${status}_${currentExt}`, time);
                                sendEpsilonTime(`load_${status}_${currentExt}`, time);
                            }

                            const frameTime = Date.now() - frameStartTime;

                            radar.add('frame-load', frameTime);
                            radar.add(`${'frame-load_'}${currentExt}`, frameTime);
                            radar.add(`frame-load_${status}`, frameTime);
                            radar.add(`frame-load_${status}_${currentExt}`, frameTime);
                            sendEpsilonTime(`frame-load_${status}_${currentExt}`, frameTime);

                            radar.send();
                        };

                        const frameStartTime = Date.now();

                        addEditorMessageListener();

                        editor
                            .start(document.querySelector('#editor-container'), frameData?.edit_url || frameData?.view_url, current.mode, {
                                access_token: frameData.access_token,
                                access_token_ttl: frameData.access_token_ttl || 0,
                            })
                            .fail(() => {
                                // Не загрузился iframe с редактором,
                                // показываем пользователю Облачную ошибку.
                                sendInfo('error', frameStartTime);
                                // reduxStore.dispatch(routeStatusPage({ status: EStatus.INTERNAL_SERVER_ERROR })); CLOUDWEB-6024
                            })
                            .always(() => {
                                if (editorWaiting) {
                                    editorWaiting.style.display = 'none';
                                }
                            });

                        editor
                            .on('timeout', () => {
                                // Событие iframe.load сработало, но в течение
                                // установленнного времени так и не пришло
                                // ни одного сообщения от редактора.
                                // Вероятно редактор показал какую-то ошибку.
                                sendInfo('error', frameStartTime);
                            })
                            .on('sharing', () => {
                                publishHelper({ item: app.current() });
                            })
                            .on('start', () => {
                                sendViewerDwh({
                                    id_public: 'None',
                                    source: 'home',
                                    type_content: item?.kind,
                                    extension: item?.ext?.toLowerCase() || '',
                                    action: 'open-content',
                                    is_full_render: true,
                                    is_edit: true,
                                    size_files: item.size,
                                });
                                sendInfo('success', frameStartTime);
                            })
                            .on('rename', (_: any, params: any) => {
                                const { newName } = params;

                                if (!newName) {
                                    return;
                                }

                                const splitPathName = window.location.pathname.split('/');
                                const withoutFileName = splitPathName.slice(0, -1).join('/');
                                // в current.ext лежит оригинальное расширение до применения toLowerCase
                                const fullName = `${newName}.${current.ext}`;
                                const url = `${withoutFileName}/${fullName}`;
                                const title = `${fullName} / Облако Mail.ru`;

                                app.replaceState(title, url);
                            });
                    }
                };

                app.once('routeEnd', onRouteEnd);
                sessionWatcher.init();
            },
        },
    });
};

export default Editor;
